/* eslint-disable no-undef */
import 'enhancements/validityChecker';
import 'enhancements/userExistsChecker';
import 'enhancements/podcastFinder';

import { partialReplacementForm } from 'enhancements/partialReplacementForm';
import { delegate } from "../utils/delegate";

require('@rails/ujs').start();

partialReplacementForm({
  formSelector: '.signup-form',
  targetSelector: '#signup-content'
});

/** Handle the contact us form */
delegate({
  baseSelector: 'body',
  selector: 'form.contact',
  eventName: 'submit',
  handler: (e) => {
    e.preventDefault();
    Beacon('prefill', {
      name: e.target.elements["contact[name]"].value,
      email: e.target.elements["contact[email]"].value,
      subject: "Multi-Show Account"
    });
    Beacon('navigate', '/ask/message');
    Beacon('open');
  }
});

delegate({
  baseSelector: 'body',
  selector: '#invalid-email-beacon',
  eventName: 'click',
  handler: (e) => {
    e.preventDefault();
    Beacon('open');
  }
});

